import { cn } from '@/platform/lib/utils';
import { DialogTitle } from '@headlessui/react';

const ModalHeader = ({ className, children, ...props }) => (
    <DialogTitle
        as='h2'
        className={cn(
            'text-base font-semibold text-balance text-gray-900',
            className
        )}
        {...props}
    >
        {children}
    </DialogTitle>
);

export default ModalHeader;
